// extracted by mini-css-extract-plugin
export default {"switch-container":"StatusToggle_switch-container__4kHrD","checkbox":"StatusToggle_checkbox__Iwmb2","switch":"StatusToggle_switch__faanD","slider":"StatusToggle_slider__irJQf"};